require('./header');
require('./cart');
require('./swiper');
require('./select2');
require('./sticky-product');
require('./input-sync');
require('./related-products');

window.variables = require(process.env.themeFolder);
